import * as React from 'react';
import styled from 'styled-components';
import FaqItem, { IFaqItem } from '@adecco/base-app/src/components/atoms/FaqItem/FaqItem';
import Headline from '@adecco/base-app/src/components/atoms/Headline/Headline';
import Container from '@adecco/base-app/src/components/atoms/Container/Container';
import { moreThan } from '@adecco/base-app/src/constants/breakpoints/breakpoints';

export interface IFaqList {
  title?: string;
  entries: ReadonlyArray<IFaqItem>;
  centeredHeadline?: boolean;
}

const FaqListItem = styled.div`
  width: 100%;
  margin: ${(props) => props.theme.margins.listItem};
`;

const FAQHeadline = styled(Headline)`
  margin: ${(props) => props.theme.margins.faqHeadline};
  font-family: ${(props) => props.theme.fonts.HeadlineBold};
  font-size: ${(props) => props.theme.fontSizes.headline2};
  line-height: ${(props) => props.theme.lineHeights.headline2};

  ${moreThan('md')} {
    font-size: ${(props) => props.theme.fontSizes.headline2WideScreen};
    line-height: ${(props) => props.theme.lineHeights.headline2WideScreen};
  }
`;

const LocationAccordion: React.FunctionComponent<IFaqList> = ({
  title,
  entries,
  centeredHeadline,
}) => (
  <Container>
    {entries.map((slugEntry, index) => (
      <span key={`slug-${slugEntry.slug}-${index}`} id={slugEntry.slug} />
    ))}
    <FAQHeadline skin={2} centered={centeredHeadline}>
      {title}
    </FAQHeadline>
    {entries.map((entry, index) => (
      <FaqListItem key={`jobFact-${index}`}>
        <FaqItem {...entry} />
      </FaqListItem>
    ))}
  </Container>
);

export default LocationAccordion;
